/* eslint-disable jsx-a11y/anchor-has-content,jsx-a11y/label-has-for */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import connect from 'react-redux/es/connect/connect';

// eslint-disable-next-line react/prefer-stateless-function
class TimeTargetOptionsPopUp extends Component {
  render() {
    let spentAmountDesc = null;
    if (
      this.props.timeTargetTaskCurrentOptions &&
      this.props.timeTargetTaskCurrentOptions.spent_amount !== null
    ) {
      if (this.props.timeTargetTaskCurrentOptions.spent_amount > 0) {
        spentAmountDesc = (
          <div className="alert alert-success text-center">
            На текущий период доступно{' '}
            {this.props.timeTargetTaskCurrentOptions.spent_amount} из{' '}
            {this.props.timeTargetTaskCurrentOptions.max_amount} выполнений.
          </div>
        );
      } else if (this.props.timeTargetTaskCurrentOptions.spent_amount <= 0) {
        spentAmountDesc = (
          <div className="alert alert-warning text-center">
            На текущий период все{' '}
            {this.props.timeTargetTaskCurrentOptions.max_amount} из{' '}
            {this.props.timeTargetTaskCurrentOptions.max_amount} позиций заняты.
          </div>
        );
      }
    }

    const weekdaysDecorator = weekdays => {
      if (weekdays[0] === 0) {
        weekdays.push(weekdays.shift());
      }
      return weekdays.map(v => this.props.weekdays[v]).join(', ');
    };

    return (
      <React.Fragment>
        <div
          aria-labelledby="myModalLabel"
          className="modal fade"
          role="dialog"
          tabIndex="-1"
          id={this.props.id}
        >
          <div className="modal-dialog modal-gray modal-sm">
            <div className="modal-content">
              <div className="modal-header text-center">
                <a
                  aria-label="Close"
                  className="close close-black"
                  data-dismiss="modal"
                  href=""
                />
                <i className="fa fa-clock-o modal-icon" />
                <h4 className="modal-title">
                  <strong>Таргетинг по времени</strong>
                </h4>
              </div>
              <div className="modal-body p-b-0">
                {this.props.timeTarget &&
                  this.props.timeTarget.map((item, index) => (
                    <div
                      key={`${this.props.id}-${index + 1}`}
                      className="panel panel-heading_padding-large panel-default m-b-20"
                      id="periodTime0"
                    >
                      <div className="panel-heading panel-inner-border-bottom">
                        <p className="form-control-static">
                          {weekdaysDecorator(item.weekdays)}{' '}
                        </p>
                      </div>
                      <div className="panel-body">
                        <label className="control-label">
                          Время выполнения:
                        </label>
                        {item.times.map((v, i) => (
                          <div
                            key={`${this.props.id}-${index + 1}-${i + 1}`}
                            className="form-inline text-nowrap form-inline_no-breakpoint"
                          >
                            <p className="form-control-static p-b-0">
                              {`${i + 1}. ${v.time_from} - ${v.time_to}`}{' '}
                              {v.max_amount ? (
                                <span className="text-muted">
                                  Максимум <strong>{v.max_amount}</strong>{' '}
                                  выполнений
                                </span>
                              ) : (
                                <span className="text-muted">
                                  Без ограничений
                                </span>
                              )}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                {spentAmountDesc}
              </div>
              <div className="modal-footer">
                <a
                  className="btn btn-muted"
                  data-dismiss="modal"
                  href=""
                  type="button"
                >
                  Закрыть
                </a>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

TimeTargetOptionsPopUp.defaultProps = {
  timeTargetTaskCurrentOptions: null
};

TimeTargetOptionsPopUp.propTypes = {
  id: PropTypes.string.isRequired,
  timeTargetTaskCurrentOptions: PropTypes.shape({
    max_amount: PropTypes.number,
    spent_amount: PropTypes.number
  }),
  timeTarget: PropTypes.arrayOf(PropTypes.shape).isRequired,
  weekdays: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => ({
  weekdays: getItemFromRefList(state, 'weekdays')
});

export default withRouter(connect(mapStateToProps)(TimeTargetOptionsPopUp));



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/TimeTargetOptionsPopUp/TimeTargetOptionsPopUp.js